import request, { authOptions } from 'api/requestUtils'
import { diffInDays } from 'lib/datetime/dateUtils'
import type { HotelSightOutcome } from 'lib/metasearch/hotelSight'

// Book now waits on this alongside the mint. svc-order answers in ~1.5s and caps its AI
// step at 2.5s; a slower answer is dropped and the member is not flagged.
const HOTEL_SIGHT_API_TIMEOUT_MS = 3000

// Search and landing URLs prefix bedbank property ids; svc-order validates a bare UUID.
const BEDBANK_PROPERTY_ID_PREFIX = /^bedbank:/

export interface CheckHotelSightInput {
  propertyId: string
  checkIn: string
  checkOut: string
}

interface HotelSightRequest {
  propertyId: string
  checkIn: string
  nights: number
}

interface HotelSightResponse {
  applyPublicRate?: true
}

/**
 * Asks svc-order whether to withhold the GHA discount from the signed-in member. Members
 * only: the member comes from the login, and a guest gets a 401. Never rejects.
 */
export function checkHotelSight(input: CheckHotelSightInput): Promise<HotelSightOutcome> {
  return request.post<HotelSightResponse, HotelSightRequest>(
    '/api/orders/hotel-sight',
    {
      propertyId: input.propertyId.replace(BEDBANK_PROPERTY_ID_PREFIX, ''),
      checkIn: input.checkIn,
      nights: diffInDays(new Date(input.checkIn), new Date(input.checkOut)),
    },
    {
      ...authOptions(),
      timeout: HOTEL_SIGHT_API_TIMEOUT_MS,
      // The body schema rejects unknown fields, including the `brand` the request layer appends.
      excludeBrand: true,
    },
  ).then((response): HotelSightOutcome => (
    response?.applyPublicRate === true ? 'flagged' : 'clear'
  )).catch((): HotelSightOutcome => 'failed')
}
